export const color = {
  primary: {
    100: "#F9DDDC",
    200: "#ED9895",
    300: "#E1544E",
    400: "#CF3730",
    500: "#C23E38"
  },


  green: {
    300: "#2F646A"
  },

  success: {
    100: "#B4DBD9",
    200: "#8FC9C6",
    300: "#6AB7B3"
  },

  alert: {
    100: "#FCF7ED",
    200: "#ECC077",
    300: "#E6AB4A"
  },

  warning: {
    100: "#F1BAA0",
    200: "#E99168",
    300: "#E77945"
  },

  neutral: {
    100: "#ffffff",
    200: "#ECECEC",
    300: "#e1e1e1",
    400: "#B6BABD",
    450: "#9597A1",
    500: "#4a4b53",
    550: "#45494D",
    600: "#2E2E2E"
  }
}
